/**
* Review Slideshow Script
* ------------------------------------------------------------------------------
*
* @namespace - ReviewSlideshow
*/

var Slideshow = require("../../slideshow/js/slideshow");
var utils = require('../../utilities/js/utils');

var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    prevArrow: '[data-prev-arrow]',
    nextArrow: '[data-next-arrow]'
};

/**
* Review slideshow constructor
*
* @param {string} container - selector for the section container DOM element
*/
function ReviewSlideshow(container) {
    container = container || 'body';
    this.$container = $(container);

    this.name = 'slideshow';
    this.namespace = '.'+this.name;

    if( !$(selectors.slideshowWrapper, this.$container).length ){

        return;
    }

    var settings = {
        dots: true,
        prevArrow: $(selectors.prevArrow),
        nextArrow: $(selectors.nextArrow)
    };

    this.slideshow = new Slideshow( $(selectors.slideshowWrapper, this.$container ), settings);
};

module.exports = ReviewSlideshow;



//////////////////
// WEBPACK FOOTER
// ./slideshow/js/reviewSlideshow.js
// module id = 139
// module chunks = 3